module.exports = __webpack_public_path__ + "img/striker.59e1944e.png";